/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiMerchantData, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiMerchantDataFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiMerchantDataToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiMerchantData';
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiMerchantData(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiMerchantDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiMerchantData(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassnikiMerchantDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultOdnoklassniki.js.map